export enum ConsultantStatus {
  Active = "Active",
  Unverified = "Unverified",
  Verified = "Verified",
  ToBeDeleted = "ToBeDeleted",
  Deleted = "Deleted"
}
